import React from 'react'

import { getFeedNameKey } from 'mednet-util/src/feed'

import { default as StatefulFeedItem } from './statefulFeedItem'

class UserPublicationFeedItem extends React.Component {
  render() {
    const { feedName, feedKey } = this.props

    return (
      <StatefulFeedItem
        indexPath={`feed.feeds[${getFeedNameKey(feedName, feedKey)}].items`}
        {...this.props}
      />
    )
  }
}

export default UserPublicationFeedItem
